import { axiosInstance } from "./axios-instance";

export const userServices = {

    getActiveServices: async (jwt) => {
        const auth = `${jwt}`

        const data = axiosInstance.get(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/serviceApp/active`,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
                data: {}
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    getUserGroupEvents: async (jwt, email) => {
        const auth = `${jwt}`;
        const today = new Date();
        const year = today.getUTCFullYear();
        const month = today.getUTCMonth() + 1;

        const data = axiosInstance.get(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/group/service/user/list?customerEmail=${email}&month=${month}&year=${year}`,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
                data: {}
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    validateGroupEvent: async (jwt, timifyId) => {
        const auth = `${jwt}`;
        const data = axiosInstance.post(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/purchaseOrder/event/validate`,
            {
                eventTimifyId: timifyId
            },
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                }
            }).catch(errors => {
                console.log(errors);
                return ({ data: data });
            });
        return data;
    },

    queryCodeInfo: async (jwt, code) => {
        const auth = `${jwt}`;
        const data = axiosInstance.get(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/group/service/byCode/${code}`,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
                data: {}
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    scheduleByCode: async (jwt, scheduleData) => {
        const auth = `${jwt}`;
        const data = axiosInstance.put(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/group/service/add`,
            scheduleData,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    exitGroup: async (jwt, timifyId, email) => {
        const auth = `${jwt}`;
        const data = axiosInstance.delete(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/trans/group/service/delete/${timifyId}?customerEmail=${email}`,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
                data: {}
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    groupLeaveReason: async (jwt, bodyData) => {
        const auth = `${jwt}`;
        const data = axiosInstance.put(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/user/generalData/add`,
            {
                dataKey: "RETIRO_GRUPO_APOYO",
                dataValue: bodyData
            },
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    userHasSubscription: async (jwt) => {
        const auth = `${jwt}`;
        const data = axiosInstance.get(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/user/subscription`,
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
                data: {}
            }).catch(errors => {
                console.log(errors);
                return ({ data: undefined });
            });
        return data;
    },

    createContactInfo: async (jwt,document,email,cellphone) => {
        const auth = `${jwt}`;
        const data = axiosInstance.post(
            `${process.env.URL_REDAMOR_USER}/redamor/common/api/v1.0/createContact`,
            {
                document: document,
                email: email,
                cellPhone: cellphone
            },
            {
                headers: {
                    'Authorization': auth,
                    'Content-Type': 'application/json'
                },
            }
            ).catch(errors => {
                console.log(errors);
                return ({ data: data });
            });
        return data;
    },
}